import axios from 'axios';

// Default API URLs
const defaultAPI = process.env.REACT_APP_API_KEY || 'https://api.example.com';
const appAPI = process.env.REACT_APP_APP_LEGIS_API_KEY || 'https://app-api.example.com';

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: defaultAPI,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 seconds timeout
});

// Request Interceptor - Add Authorization Token & Change baseURL dynamically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Get token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Check for custom parameter `app`
    if (config.params && config.params.app) {
      config.baseURL = appAPI;
      delete config.params.app; // Remove `app` parameter to prevent unnecessary API errors
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor - Handle Errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.error('Unauthorized! Redirecting to login...');
          break;
        case 403:
          console.error('Forbidden! You do not have permission.');
          break;
        case 500:
          console.error('Server Error! Please try again later.');
          break;
        default:
          console.error('An error occurred:', error.response.data?.message || error.message);
      }
    } else if (error.request) {
      console.error('No response received from server:', error.request);
    } else {
      console.error('Error setting up request:', error.message);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
